export type PlanFeature = {
  label: string
  included: boolean
  bold?: boolean
}

export type Plan = {
  id: 'starter' | 'complete'
  name: string
  compareAt: number
  price: number
  features: PlanFeature[]
}

export const plans: Plan[] = [
  {
    id: 'starter',
    name: 'Starter',
    compareAt: 281,
    price: 27,
    features: [
      { label: 'The Calm Mornings System — 10+ visual routines, boards, time tracker', included: true },
      { label: 'All 12 bonuses (worth $184 — see them below ↓)', included: true },
      { label: 'Emotions & Calm Corner Pack', included: false },
      { label: 'The Focus Pack — for kids with ADHD or autism', included: false },
      { label: 'Free updates for life', included: false },
    ],
  },
  {
    id: 'complete',
    name: 'Complete',
    compareAt: 355,
    price: 37,
    features: [
      { label: 'The Calm Mornings System — 10+ visual routines, boards, time tracker', included: true },
      { label: 'All 12 bonuses (worth $184 — see them below ↓)', included: true },
      { label: 'Emotions & Calm Corner Pack', included: true, bold: true },
      { label: 'The Focus Pack — for kids with ADHD or autism', included: true, bold: true },
      { label: 'Free updates for life', included: true, bold: true },
    ],
  },
]
